import { createStore, applyMiddleware } from 'redux';

import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import rootReducer from './reducers/rootReducer';
import requestMiddleware from './middleware/request';
import { trackingMiddleware } from './tracking';

export default function configureStore(initialState) {
  const middleware = applyMiddleware(
    thunkMiddleware,
    requestMiddleware,
    trackingMiddleware,
  );

  const enhancers = composeWithDevTools(middleware);

  return createStore(rootReducer, initialState, enhancers);
}
